export default function MobileBottomBar() {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50 border-t border-background-200 shadow-[0_-2px_10px_rgba(0,0,0,0.08)]">
      <div className="grid grid-cols-4 gap-1 px-2 py-2">
        <a
          href="tel:+79174131562"
          className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-md text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-fill text-lg"></i>
          </span>
          <span className="text-[10px] font-medium">Позвонить</span>
        </a>

        <a
          href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-md text-foreground-700 hover:text-accent-500 hover:bg-accent-50 transition-colors duration-200 cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-chat-3-line text-lg"></i>
          </span>
          <span className="text-[10px] font-medium">MAX</span>
        </a>

        <a
          href="https://t.me/Gmgmg0202"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-md text-foreground-700 hover:text-[#2AABEE] hover:bg-blue-50 transition-colors duration-200 cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-telegram-line text-lg"></i>
          </span>
          <span className="text-[10px] font-medium">Telegram</span>
        </a>

        <a
          href="#cta-form"
          className="flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-calculator-line text-lg"></i>
          </span>
          <span className="text-[10px] font-medium">Рассчитать</span>
        </a>
      </div>
    </div>
  );
}